import { inject, InjectionToken } from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import { ScreenshotDetectService } from '../services';

export const SCREENSHOT_DETECT_TOKEN: InjectionToken<ScreenshotDetectProvider> =
  new InjectionToken<ScreenshotDetectProvider>('SCREENSHOT_DETECT_TOKEN', {
    factory: (): ScreenshotDetectProvider => {
      const screenshotDetectService: ScreenshotDetectService = inject(ScreenshotDetectService);

      return {
        isSupported(): Promise<boolean> {
          return screenshotDetectService.isSupported();
        },

        startListening(): Promise<void> {
          return screenshotDetectService.startListening();
        },

        stopListening(): Promise<void> {
          return screenshotDetectService.stopListening();
        },

        addListener(callback: () => void): Promise<PluginListenerHandle> {
          return screenshotDetectService.addListener(callback);
        }
      };
    }
  });

export interface ScreenshotDetectProvider {
  isSupported(): Promise<boolean>;
  startListening(): Promise<void>;
  stopListening(): Promise<void>;
  addListener(callback: () => void): Promise<PluginListenerHandle>;
}
